<template>
  <navigation-menu-item target-path="account-settings" title="הגדרות מנוי" v-on:navigate="$emit('navigate')" :icon="icon"/>
</template>

<script>
import { mapState } from 'vuex';
import NavigationMenuItem from './NavigationMenuItem.vue';
import { SUBSCRIPTION_STATES } from '../../constants/subscription-state';

export default {
  name: 'AccountSettingsMenuItem',
  components: { NavigationMenuItem },
  computed: {
    ...mapState('discountPromotion', ['eligibleForDiscountPromotion']),
    ...mapState('benefits', ['benefitType']),
    ...mapState('subscriptionState', ['subscriptionState']),
    eligibleSubscriptionState() {
      return _.includes([SUBSCRIPTION_STATES.TRIAL, SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL], this.subscriptionState);
    },
    showDiscountPromotionIcon() {
      return this.eligibleForDiscountPromotion && this.eligibleSubscriptionState;
    },
    showBenefitIcon() {
      return this.benefitType && this.eligibleSubscriptionState;
    },
    icon() {
      if (this.showDiscountPromotionIcon) {
        return 'discount-benefit.svg';
      }
      if (this.showBenefitIcon) {
        return 'benefit.svg';
      }
      return null;
    },
  },
};
</script>
